// Core
import React from "react";

// Styles
import "./styles.scss";

const CircleImageView = ({ imageUrl, size = 50 }) => {
  return (
    <div
      className="round-image-container"
      style={{ width: size, height: size }}
    >
      <img src={imageUrl} alt="Rounded" className="round-image" />
    </div>
  );
};

export default CircleImageView;
